import { Button, Menu, MenuItem } from "@mui/material";
import { Box } from "@mui/system";
import React, { FC, useEffect, useState } from "react";
import { PageHeading } from "../../Components/page-heading.component";
import threedots from "../../assets/images/threedots.svg";
import { useNavigate } from "react-router-dom";
import { LeadService } from "../../Services/leads.service";
import { GetAllDto } from "../../Shared/dto/get-all-dto";
import { LeadModel } from "../../Models/lead.model";
import { DisplayDate, FormatDate } from "../../Shared/services/date-format";
import { useLoading } from "../../Shared/services/loading-context";
import { useSnackbar } from "notistack";

interface LeadsProps {
  contactId?: number;
}

const Leads: FC<LeadsProps> = (props) => {
  const [leadsListing, setLeadsListing] = useState<LeadModel[]>([]);
  const [anchorE2, setAnchorE2] = React.useState<null | HTMLElement>(null);
  const [actionToggle, setActionToggle] = useState<any>(false);
  const [rowValue, setRowValue] = useState<any>();
  const { loading, setLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();
  const redirectAddLeads = () => {
    navigate("/leads/addleads");
  };

  const getLeadsData = async (searchQuery?: string) => {
    const getAllDto = new GetAllDto("leadDate", props.contactId);
    if (searchQuery) {
      getAllDto.searchQuery = searchQuery;
    }
    setLoading(true);
    const response = await LeadService.get(getAllDto);
    setLoading(false);
    if (response.success) {
      setLeadsListing(response.data);
    } else enqueueSnackbar(response.message ?? "Internal server error", { variant: "error" });
  };

  useEffect(() => {
    // getLeadsData();
  }, []);

  const handleCloseEditDelete = () => {
    setActionToggle(false);
  };

  const editDeleteDropdown = (
    event: React.MouseEvent<HTMLButtonElement>,
    currElemId: any
  ) => {
    setRowValue(currElemId);
    setAnchorE2(event.currentTarget);
    setActionToggle(true);
  };

  const handleEdit = () => {
    navigate(`/leads/${rowValue}`);
  };

  return (
    <div>
      <PageHeading
        title="Leads"
        addNew={redirectAddLeads}
        hasFilter={true}
        onSearch={getLeadsData}
      />

      {leadsListing.map((currElem: any) => {
  return (
    <div key={currElem.id} className="lead-box"> {/* ✅ Key added here */}
      <Box className="payment-box inner-lead-box row">
        <div className="col-md-3 col-lg-3">
          <span className="leads-date">
            {DisplayDate(currElem.leadDate)}
          </span>
          <br />
          <span className="leads-opportunity">{currElem.leadStage}</span>
        </div>

        <div className="payment-textalign col-lg-3 col-md-3 website-text-centered">
          <span className="lead-person-name">{currElem.contact?.name}</span>
        </div>

        <div className="payment-textalign col-lg-3 col-md-3 website-text-centered">
          <span className="leads-website-list">{currElem.sourceOfPromotion}</span>
        </div>

        <div className="website-text-centered col-md-2 col-lg-2">
          <span className="lead-person-name-second">{currElem.salesPerson}</span>
        </div>

        <div className="website-text-centered col-md-1 col-lg-1">
          <Button
            onClick={(event) => editDeleteDropdown(event, currElem.id)}
          >
            <img src={threedots} />
          </Button>
          <Menu
            anchorEl={anchorE2}
            open={actionToggle}
            onClose={handleCloseEditDelete}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              key={currElem.contactName + "_edit"}
              onClick={handleEdit}
            >
              Edit
            </MenuItem>
            <MenuItem>Delete</MenuItem>
            <MenuItem>Change Stage</MenuItem>
            <MenuItem>Change Owner</MenuItem>
          </Menu>
        </div>
      </Box>
    </div>
  );
})}

    </div>
  );
};

export default Leads;
